import { useState } from 'react';
import { InlineButton } from '@picsart/design-system/components/InlineButton';
import { IconDelete } from '@picsart/design-system/foundation/icons/IconDelete';
import InlineMedia from '@/components/InlineMedia';
import UploadingOverlay from './UploadingOverlay';
import useStyles from './styles';
import type { FilePreviewProps } from './types';

const FilePreview = ({
  previewUrl,
  isVideo,
  isLoading,
  isRemoving,
  compact,
  onRemove,
}: FilePreviewProps) => {
  const classes = useStyles();
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const isBroken = failedUrl === previewUrl;

  return (
    <div
      className={`${classes.preview} ${compact ? classes.previewCompact : ''} ${
        isRemoving ? classes.previewRemoving : ''
      }`}
    >
      {!isBroken && (
        <InlineMedia
          className={classes.previewMedia}
          src={previewUrl}
          isVideo={isVideo}
          alt="Preview"
          preload="metadata"
          onError={() => setFailedUrl(previewUrl)}
        />
      )}

      {(isLoading || isBroken) && <UploadingOverlay isVideo={isVideo} />}

      {onRemove && !isLoading && (
        <span className={classes.removeButton}>
          <InlineButton
            size="small"
            centerIcon={IconDelete}
            onClick={onRemove}
            aria-label="Remove"
            className={classes.iconButton}
            dataTestId="file-preview-remove"
            isWithoutBorder
          />
        </span>
      )}
    </div>
  );
};

export default FilePreview;
